/**
 * KAN-849 (Ship 0) — display-only mirror of the server's month estimate. The
 * server value (`estimate_amount`) is the source of truth; this only lets the
 * Plans screen and tests reason about the same rule. Money is DOLLARS.
 *   flat     -> flat_price
 *   per_pool -> min(cap, max(min, pools * rate)), null min/cap ignored
 *   other    -> null (custom: priced per company)
 */
const num = (v) => (v === null || v === undefined || v === '' ? null : Number(v));

export function planMonthEstimate({ pricing_kind: kind, flat_price: flat, per_pool_rate: rate, min_monthly: min, cap_monthly: cap } = {}, pools = 0) {
  if (kind === 'flat') return num(flat);
  if (kind !== 'per_pool') return null;
  const r = num(rate);
  if (r === null) return null;
  let amount = (Number(pools) || 0) * r;
  const lo = num(min);
  const hi = num(cap);
  if (lo !== null) amount = Math.max(lo, amount);
  if (hi !== null) amount = Math.min(hi, amount);
  return Math.round(amount * 100) / 100;
}

/** True when the estimate sits on the cap (per-pool only). */
export function isAtCap(plan, pools) {
  if (plan?.pricing_kind !== 'per_pool' || num(plan.cap_monthly) === null) return false;
  const r = num(plan.per_pool_rate);
  return r !== null && (Number(pools) || 0) * r >= Number(plan.cap_monthly);
}

/** Past the plan's included pools (Solo's nudge). Null included = never. */
export function isPastIncluded(includedPools, pools) {
  const inc = num(includedPools);
  return inc !== null && (Number(pools) || 0) > inc;
}
